import { Component, Input, OnInit } from '@angular/core';
import { SupplierService } from '../../../services';
import { JobsService } from '../../../services';
import { IProfileJobInfo } from '../../../interfaces/telephony/profile-job-info';

@Component({
  selector: 'supplier-watched-jobs',
  templateUrl: './supplier-watched-jobs.component.html',
  styleUrls: ['./supplier-watched-jobs.component.scss'],
})
export class SupplierWatchedJobsComponent implements OnInit {
  @Input() supplierId: number;
  @Input() supplierHomePos: any;
  @Input() impersonating: boolean;
  @Input() noCallLink: boolean;

  constructor(private jobService: JobsService, private supplierService: SupplierService) {}

  isLoading = true;
  jobs: IProfileJobInfo[];
  showOnlyUnassigned = 0;

  viewJobs: IProfileJobInfo[];

  ngOnInit() {
    // load closed jobs
    this.loadJobs();
  }

  loadJobs() {
    this.isLoading = true;

    let dto = {
      supplierId: this.supplierId,
      numberToRetrieve: 20,
    };

    this.jobService.getSupplierWatchedJobs(dto).then((result) => {
      this.jobs = result;
      this.showJobsValChanged(0);
      this.isLoading = false;

      console.log('Watched Jobs: ', this.jobs);
    });
  }

  showJobsValChanged(event) {
    const showOnlyUnassigned = event.option?.value;

    this.viewJobs =
      showOnlyUnassigned == 1
        ? this.jobs.filter((x) => !x.supplierId && x.statusId == 5)
        : this.jobs;

    this.viewJobs = [...this.viewJobs];
  }
}
